import React, { useState, useEffect } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const Card24 = () => {
  const [value, setValue]   = useState(null);
  const [error, setError]   = useState(false);

  useEffect(() => {
    fetch(`${API}/inventaire/en-cours`)
      .then(res => { if (!res.ok) throw new Error('Erreur API ' + res.status); return res.json(); })
      .then(data => setValue(data.count))
      .catch(err => { console.error('Card24 :', err); setError(true); setValue(0); });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '120px', width: '220px', backgroundColor: '#ffffff', border: '1px solid #f0ece2', borderRadius: '14px', padding: '16px 20px', boxSizing: 'border-box', position: 'relative', overflow: 'hidden', cursor: 'pointer' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #04202d, #38bdf8)', borderRadius: '14px 14px 0 0' }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '28px', height: '28px', backgroundColor: '#e0f2fe', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>
        </div>
        <span style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '15px', fontWeight: '500', color: '#8b7b64', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Inventaire en cours / à faire
        </span>
      </div>
      <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '32px', fontWeight: '600', color: error ? '#ef4444' : '#0f172a', lineHeight: 1, textAlign: 'center' }}>
        {value === null
          ? <span style={{ fontSize: '20px', color: '#cbd5e1' }}>—</span>
          : value
        }
      </div>
    </div>
  );
};

export default Card24;